import * as Yup from 'yup'
import { Form,  Col, Row } from 'react-bootstrap'
import LocalizedStrings from 'react-localization';
import { Options } from '../SelectOptions';
import { CustomFormSelect } from '../../../../StyledComponents';
import { ClientLanguage, getClientLanguageAsString } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        salutation: "Anrede*",
        salutationPlaceholder: "Bitte auswählen...",
        salutationRequired: "Angabe ist erforderlich",
    },
    en:
    {
        salutation: "Salutation*",
        salutationPlaceholder: "Please select...",
        salutationRequired: "Information required",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (clientLanguage) => Yup.object().shape({
    salutation: Yup.string()
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required(locStrings.salutationRequired);
              },
        }),
});

export const SalutationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, clientLanguage } = props;

    setLanguage(clientLanguage);

    function getClientLanguage(): string { 
        return getClientLanguageAsString(clientLanguage); 
    } 
    
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formSalutation">
                    <Form.Label>{locStrings.salutation}</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="salutation"
                        value={values.salutation}
                        isValid={touched.salutation && !errors.salutation}
                        isInvalid={touched.salutation && errors.salutation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">{locStrings.salutationPlaceholder}</option>
                        {clientLanguage == ClientLanguage.English ?
                        Options.SalutationEnglish.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        :Options.SalutationGerman.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        }
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.salutation}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col}>
                </Form.Group>
            </Row>
        </>
    );
};